module.exports = __webpack_public_path__ + "img/jh_404.b2e3da28.png";